module.exports = __webpack_public_path__ + "static/media/Site_Tech.3c657951.jpg";